import React from 'react';
import { validatePermission } from 'actions';
import ApplicationLayout from 'v3/layouts/Application';
import KanbanWorkspace from './Workspace';
import { canReadKanban } from './contract';
import integrations, { rowIntegrations } from './integrations';
import useCurrentCompanyId from './useCurrentCompanyId';

export default function KanbanPage() {
  const companyId = useCurrentCompanyId();
  return (
    <ApplicationLayout title="Kanban de cargas" contentFluid maxWidth="100%" compactHeader>
      <KanbanWorkspace
        companyId={companyId}
        canView={companyId !== null && canReadKanban(validatePermission)}
        canViewPreLoads={validatePermission('VISUALIZAR_PRECARGA')}
        integrations={integrations}
        rowIntegrations={rowIntegrations}
      />
    </ApplicationLayout>
  );
}
